module.exports = __webpack_public_path__ + "static/media/villa-azul-2.eb05cef2.webp";